import { MyInternalLink, MyLink, MyLinkSiteActivityPropsV2 } from 'components/MyLink'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useLegacyPremiumsHref } from 'hooks/useLegacyPremiumsHref'
import { useTranslation } from 'react-i18next'
import { ArrowIcon } from '@cmsgov/ds-medicare-gov'
import { buildAbsoluteMedicareMyUrl } from 'utils/urls/buildAbsoluteMedicareMyUrl'
import { Component } from '@cms-max/medicare-api-sdk'

export function BackToPremiumsLink () {
  const { t } = useTranslation('easyPaySummary')
  const flags = useFlags()
  const legacyPremiumsHref = useLegacyPremiumsHref()

  const linkSiteActivityProps: MyLinkSiteActivityPropsV2 = {
    core: {
      coreClickData: {
        linkText: t('backToPremiums'),
        linkUrl: buildAbsoluteMedicareMyUrl('/premiums')
      },
      component: Component.Premiums,
      elementId: 'premiums_backtopremiums_click'
    }
  }

  // Event tracking
  return (
      <>
        {flags?.useNewPremiumsPay && (
          <>
            <MyInternalLink
              to={`/premiums`}
              className='ds-u-text-decoration--none'
              siteActivityProps={linkSiteActivityProps}
            >
              <ArrowIcon direction="left" className='ds-u-margin-right--1' />
              <span className='ds-c-link'>{t('backToPremiums')}</span>
            </MyInternalLink>
          </>
        )}

        {!flags?.useNewPremiumsPay && (
          <>
            <MyLink
              href={legacyPremiumsHref}
              className='ds-u-text-decoration--none'
              siteActivityProps={linkSiteActivityProps}
            >
              <ArrowIcon direction="left" className='ds-u-margin-right--1' />
              <span className="ds-c-link">{t('backToPremiums')}</span>
            </MyLink>
          </>
        )}
      </>
  )
}
